interface DireccionObject {
  calle?: string;
  numero?: string;
  area?: string;
  zona?: string;
  desarrollo?: string;
  estado?: string;
  unidad?: string;
}

export const formatAddress = (direccion: string | DireccionObject | null | undefined): string => {
  if (!direccion) return 'Dirección no disponible';
  
  if (typeof direccion === 'string') {
    return direccion;
  }
  
  if (typeof direccion === 'object') {
    const parts = [
      direccion.calle || '',
      direccion.numero || '',
      direccion.area || ''
    ].filter(part => part.trim() !== '');
    
    return parts.length > 0 ? parts.join(' ') : 'Dirección no disponible';
  }
  
  return 'Dirección no disponible';
};

export const formatAddressForMaps = (direccion: string | DireccionObject | null | undefined): string => {
  if (!direccion) return '#';
  
  if (typeof direccion === 'string') {
    return direccion;
  }
  
  if (typeof direccion === 'object') {
    const parts = [
      direccion.calle || '',
      direccion.numero || '',
      direccion.area || '',
      direccion.estado || ''
    ].filter(part => part.trim() !== '');
    
    if (parts.length === 0) return '#';
    
    const fullAddress = parts.join(', ');
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(fullAddress)}`;
  }
  
  return '#';
};